export function getQueryParam(name: string): string | null {
  const urlSearchParams = new URLSearchParams(window.location.search)
  return urlSearchParams.get(name)
}
